import { FC } from 'react';
import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { Button } from '@components/Core/Button';
import { statusBadgeTranslations } from '@components/Core/StatusBadge/translations';
import { StatusType } from '@/types/common';
import { statusPopupTranslations } from './translations';
import { StatusPopupTransFields, StatusPopupProps, ActivityStatusType } from './types';

export const StatusPopup: FC<StatusPopupProps> = ({ status, text }) => {
  const {
    popupStore: { closePopup },
  } = useStore();

  const { t } = useMyTranslations<StatusPopupTransFields | ActivityStatusType>([
    statusPopupTranslations.name,
    statusBadgeTranslations.name,
  ]);

  return (
    <div className="flex flex-col justify-stretch items-center">
      <p className="default-text mb-[24px]">{t(status, { ns: statusBadgeTranslations.name })}</p>
      <p className={`default-text text-[#414042CC] text-center ${text && 'mb-[8px]'}`}>
        {t(`${status}Text`)}
        {text && ':'}
      </p>
      {text && <p className="default-text text-error text-center">{text}</p>}
      <Button text={t('btnText')} onClick={closePopup} styleProp="mt-[32px]" />
    </div>
  );
};
